import type { SeasonalThemeOverrides, SeasonId } from '@rover/types/src/Season';

import type { ThemeWithBreakpoints } from './themeConstants';

type SeasonalOverridesFn = (theme: ThemeWithBreakpoints) => SeasonalThemeOverrides;

const SEASONAL_OVERRIDES: Record<SeasonId, SeasonalOverridesFn> = {
  halloween: (theme) => ({ searchCardActive: theme.colors.orange['600'] }),
};

export const applySeason = (
  theme: ThemeWithBreakpoints,
  season?: SeasonId | null
): ThemeWithBreakpoints => {
  if (!season) {
    return theme;
  }
  return { ...theme, seasonal: SEASONAL_OVERRIDES[season](theme) };
};
